<template>
  <img
    class="w-10 h-6"
    :src="iconSrc"
    :alt="icon.alt"
    loading="lazy"
  >
</template>

<script lang="ts">

import type { PaymentMethodIcon } from '~~/types/cms/PaymentIcons';
import cmsImageToUrl from '~~/helpers/cms/cmsImageToUrl';

export default defineComponent({
  name: 'PaymentIcon',
  props: {
    icon: {
      type: Object as PropType<PaymentMethodIcon>,
      required: true,
    },
  },
  setup(props) {

    const iconSrc = computed(() => cmsImageToUrl(props.icon?.image));

    return { iconSrc };
  
  },
});

</script>
